import { render } from "./index.vue?vue&type=template&id=8e0d9bfc"
import script from "./managedServices.js?vue&type=script&lang=js&external"
export * from "./managedServices.js?vue&type=script&lang=js&external"

import "./managedServices.css?vue&type=style&index=0&lang=css&external"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__